export default "__VITE_ASSET__bI3pq2te__"